import api from './api';

export interface FraudSignals {
  disposableEmail: boolean;
  ipReputationLow: boolean;
  proxyVpnTor: boolean;
  deviceFingerprintAbuse: boolean;
  captchaWeak: boolean;
  rateLimitExceeded: boolean;
}

export interface FlaggedRegistration {
  id: number;
  signupAttemptId: number;
  userId?: number;
  fraudScore: number;
  signals: FraudSignals;
  status: 'pending' | 'approved' | 'rejected';
  reviewedBy?: number;
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
  user?: { id: number; email: string };
  signupAttempt?: { id: number; ipAddress: string };
}

export interface FlaggedRegistrationsResponse {
  items: FlaggedRegistration[];
  total: number;
  page: number;
  limit: number;
}

export interface FlaggedRegistrationsFilters {
  page?: number;
  limit?: number;
  status?: 'pending' | 'approved' | 'rejected';
  minScore?: number;
  maxScore?: number;
  startDate?: string;
  endDate?: string;
}

export const getFlaggedRegistrations = async (
  filters?: FlaggedRegistrationsFilters
): Promise<FlaggedRegistrationsResponse> => {
  const { data } = await api.get('/admin/fraud/flagged', { params: filters });
  return data;
};

export const approveFlaggedRegistration = async (id: number): Promise<void> => {
  await api.post(`/admin/fraud/flagged/${id}/approve`);
};

export const rejectFlaggedRegistration = async (id: number): Promise<void> => {
  await api.post(`/admin/fraud/flagged/${id}/reject`);
};

export const addDomainToBlocklist = async (domain: string): Promise<void> => {
  await api.post('/admin/fraud/blocklist/domains', { domain });
};

export const removeDomainFromBlocklist = async (domain: string): Promise<void> => {
  await api.delete(`/admin/fraud/blocklist/domains/${encodeURIComponent(domain)}`);
};

export const blockIP = async (ip: string, durationMs?: number): Promise<void> => {
  await api.post('/admin/fraud/ip/block', { ip, durationMs });
};

export const unblockIP = async (ip: string): Promise<void> => {
  await api.delete(`/admin/fraud/ip/block/${encodeURIComponent(ip)}`);
};
